import { startShareShow } from '@client/slices/entities/shows.reducer';
import { firebaseRequest, handleRequest } from '@client/listeners/lib/requests';
import { showSnackbar } from '@client/listeners/lib/snackbar';
import { setLoaderIsLoading, setLoaderIsFinishedSuccess, setLoaderIsFinishedError } from '@client/slices/helpers/loaders.reducer';
import { apiUrl } from '@sda/utils/url';
import { trackAnalytics } from '@client/intercom';
import type { ShareBeaconDto } from '@sda/functions/beacon/put-share.endpoint';
import type { AddListener } from '@client/listeners/lib';

export const shareShowListeners = (addListener: AddListener) => [
  addListener({
    actionCreator: startShareShow,
    effect: async (action, listenerApi) => {
      const { showId, email, connectionId } = action.payload;

      const { dispatch } = listenerApi;

      const scope = `send-connect-share-email${connectionId || ''}`;
      dispatch(setLoaderIsLoading(scope));

      try {
        const request = await firebaseRequest<ShareBeaconDto>({
          url: apiUrl(`show/${showId}/share`),
          method: 'POST',
          body: {
            email: email || '',
            connectionId: connectionId || '',
          },
        });

        listenerApi.fork(async () => {
          await handleRequest(request);
        });

        trackAnalytics(startShareShow);
        dispatch(setLoaderIsFinishedSuccess(scope));
      } catch (e) {
        showSnackbar(e, 'error');
        setLoaderIsFinishedError(scope, e);
      }
    },
  }),
];
